import { render } from "./Driver.vue?vue&type=template&id=074c97b7&scoped=true"
import script from "./Driver.vue?vue&type=script&lang=js"
export * from "./Driver.vue?vue&type=script&lang=js"

import "./Driver.vue?vue&type=style&index=0&id=074c97b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-074c97b7"

export default script